import axios from 'axios';
import { handleApiError } from '../global/handleApiError';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

// API function to fetch distribution lists
export const fetchDistributionLists = async (): Promise<string[]> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/distribution/lists`, {
      withCredentials: true,
    });
    return response.data.distributionLists;
  } catch (error) {
    throw new Error(handleApiError(error));
  }
};

// API function to fetch emails from a distribution list
export const fetchEmails = async (listName: string): Promise<string[]> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/distribution/${listName}/emails`, {
      withCredentials: true,
    });
    return response.data.emails;
  } catch (error) {
    throw new Error(handleApiError(error));
  }
};

// API function to add an email to a distribution list
export const addEmail = async (listName: string, email: string, csrfToken: string | null): Promise<void> => {
  if (!csrfToken) throw new Error("CSRF token not available");
  try {
    const response = await axios.post(`${API_BASE_URL}/distribution/${listName}/emails`, { email }, {
      headers: { 
        'CSRF-Token': csrfToken, 
      },
      withCredentials: true,
    });
    return response.data.message;
  } catch (error) {
    throw new Error(handleApiError(error));
  }
};

// API function to remove an email from a distribution list
export const removeEmail = async (listName: string, email: string, csrfToken: string | null): Promise<void> => {
  if (!csrfToken) throw new Error("CSRF token not available");
  try {
    const response = await axios.delete(`${API_BASE_URL}/distribution/${listName}/emails`, {
      headers: { 
        'CSRF-Token': csrfToken, 
      },
      data: { email },
      withCredentials: true,
    });
    return response.data.message;
  } catch (error) {
    throw new Error(handleApiError(error));
  }
};

// API function to update an email in a distribution list
export const updateEmail = async (listName: string, oldEmail: string, newEmail: string, csrfToken: string | null): Promise<void> => {
  if (!csrfToken) throw new Error("CSRF token not available");
  try {
    const response = await axios.put(`${API_BASE_URL}/distribution/${listName}/emails`, {
      oldEmail,
      newEmail
    }, {
      headers: { 
        'CSRF-Token': csrfToken, 
      },
      withCredentials: true,
    });
    return response.data.message;
  } catch (error) {
    throw new Error(handleApiError(error));
  }
};
